import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DateAdapter, NativeDateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { Router } from '@angular/router';

const DD_MM_YYYY_DATE_FORMATS: MatDateFormats = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

class DdMmYyyyDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}
import { NetworkingMyQuotation } from '../../../../services/mis-cotizaciones/miscotizaciones.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../../../services/security/auth.service';
import { ProbabilidadCierreService } from '../../../../services/probabilidad-cierre/probabilidad-cierre.service';
import { CanalesAtencionService } from '../../../../services/canales-atencion/canales-atencion.service';
import { ProbabilidadCierre } from '../../../../models/probabilidad-cierre/probabilidad-cierre.model';
import { CanalAtencion } from '../../../../models/canales-atencion/canales-atencion.model';
import { SeguimientoModalRequest } from '../../../../models/mis-cotizaciones/seguimiento-request.model';
import { HistorialObservacion } from '../../../../models/mis-cotizaciones/seguimiento-modal.model';
import { Base } from '../../../common/base';
import { forkJoin } from 'rxjs';

export interface DialogSeguimientoData {
  idCotizacion: number;
  numeroCotizacion: string;
  nombreCliente: string;
  fechaCreacion?: string;
  probabilidadActual?: string;
  canalesActuales?: string[];
  esColectivo?: boolean;
}

@Component({
  selector: 'app-dialog-seguimiento-cotizacion',
  templateUrl: './dialog-seguimiento-cotizacion.component.html',
  styleUrls: ['./dialog-seguimiento-cotizacion.component.css'],
  providers: [
    { provide: DateAdapter, useClass: DdMmYyyyDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_DATE_FORMATS },
  ]
})
export class DialogSeguimientoCotizacionComponent extends Base implements OnInit {
  numeroCotizacion: string = '';
  nombreCliente: string = '';
  fechaProximoContacto: Date | null = null;
  probabilidadCierre: string | null = null;
  canalesContacto: string[] = [];
  observaciones: string = '';
  observacionesError = false;
  
  // Datos de gestión existente
  idGestion: number | null = null;
  
  // Listas de opciones cargadas desde servicios
  probabilidadesCierre: ProbabilidadCierre[] = [];
  opcionesProbabilidad: string[] = [];
  
  canalesAtencion: CanalAtencion[] = [];
  opcionesCanales: string[] = [];
  
  // Historial de observaciones (de la BD)
  historialObservaciones: HistorialObservacion[] = [];
  
  // Observaciones nuevas que se agregan en esta sesión
  observacionesNuevas: string[] = [];
  
  // Fecha mínima (hoy)
  fechaMinima: Date = new Date();
  
  // Estado de carga
  isLoading: boolean = true;
  
  // Usuario actual
  usuarioGestion: string = '';

  esJefeComercial = false;
  
  constructor(
    public dialogRef: MatDialogRef<DialogSeguimientoCotizacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogSeguimientoData,
    private networking: NetworkingMyQuotation,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private probabilidadCierreService: ProbabilidadCierreService,
    private canalesAtencionService: CanalesAtencionService,
    public dialog: MatDialog,
    private router: Router
  ) {
    super();
    // Inicializar solo campos básicos
    this.numeroCotizacion = data.numeroCotizacion || '';
    this.nombreCliente = data.nombreCliente || '';
  }
  
  ngOnInit(): void {
    this.obtenerUsuario();
    this.cargarCatalogos();
  }
  
  /**
   * Obtiene el usuario actual desde el AuthService
   */
  async obtenerUsuario(): Promise<void> {
    try {
      const authInfo = await this.authService.getAuthInfo();
      const documentUser = authInfo.document;

      console.log('AuthInfo recibido:', authInfo);

      const roles =
        authInfo?.data?.usuarioDTO?.roles ??
        authInfo?.usuarioDTO?.roles ??
        authInfo?.roles ??
        [];

       this.esJefeComercial = roles.some((rol: any) => {
          const claveRol = String(rol?.claveRol || '')
            .trim()
            .toUpperCase();

          const nombreRol = String(rol?.nombreRol || '')
            .trim()
            .toUpperCase();

          return (
            claveRol === 'OVA_JEFECOMER' ||
            nombreRol === 'JEFE COMERCIAL'
          );
        }); this.esJefeComercial = roles.some((rol: any) => {
          const claveRol = String(rol?.claveRol || '')
            .trim()
            .toUpperCase();

          const nombreRol = String(rol?.nombreRol || '')
            .trim()
            .toUpperCase();

          return (
            claveRol === 'OVA_JEFECOMER' ||
            nombreRol === 'JEFE COMERCIAL'
          );
        });
      
      console.log('¿Es jefe comercial?', this.esJefeComercial);
      
      // Extraer la cédula del documento
      this.usuarioGestion = documentUser.split('.')[1].trim();
      // console.log(' Usuario de gestión:', this.usuarioGestion);
    } catch (error: unknown) {
      console.error('Error al obtener usuario:', error);
      this.esJefeComercial = false;
    }
  }
  
  /**
   * Carga los catálogos de probabilidades y canales de atención
   */
  cargarCatalogos(): void {
    this.spinner.show();
    this.isLoading = true;
    
    forkJoin({
      probabilidades: this.probabilidadCierreService.getProbabilidadesCierre(),
      canales: this.canalesAtencionService.getCanalesAtencion()
    }).subscribe({
      next: (responses) => {
        // Cargar probabilidades de cierre
        if (responses.probabilidades.status && responses.probabilidades.data) {
          this.probabilidadesCierre = responses.probabilidades.data.filter(p => p.activo === 1);
          this.opcionesProbabilidad = this.probabilidadesCierre.map(p => p.nombre.toUpperCase());
          // console.log(' Probabilidades cargadas:', this.probabilidadesCierre);
        }
        
        // Cargar canales de atención
        if (responses.canales.status && responses.canales.data) {
          this.canalesAtencion = responses.canales.data;
          this.opcionesCanales = this.canalesAtencion.map(c => c.nombre_canal.toUpperCase());
          // console.log(' Canales cargados:', this.canalesAtencion);
        }
        
        // Ahora cargar los datos de seguimiento
        this.cargarDatosSeguimiento();
      },
      error: (error) => {
        console.error(' Error al cargar catálogos:', error);
        this.spinner.hide();
        this.isLoading = false;
        
        // Cargar datos de seguimiento con valores por defecto
        this.cargarDatosSeguimiento();
      }
    });
  }
  
  /**
   * Carga los datos de seguimiento desde el servicio
   */
  cargarDatosSeguimiento(): void {
    this.networking.getSeguimientoModal(this.data.idCotizacion).subscribe({
      next: (response) => {
        if (response.status && response.data) {
          const data = response.data;
          
          // Guardar ID de gestión (null si es nuevo seguimiento)
          this.idGestion = data.idGestion;

          // Para colectivo usamos siempre el nombre de empresa pasado desde el modal (la API devuelve
          // el contratante físico, no la empresa). Para individual la API manda el nombre correcto.
          this.nombreCliente = this.data.esColectivo
            ? (this.data.nombreCliente || '')
            : (data.nombreContratante || this.data.nombreCliente || '');
          
          // Parsear y asignar fecha de próximo contacto
          if (data.fechaProxContacto) {
            this.fechaProximoContacto = this.parseFechaISO(data.fechaProxContacto);
          } else {
            // Si no hay fecha, calcular 3 días hábiles
            this.fechaProximoContacto = this.calcularFechaTresDiasHabiles();
          }
          
          // Asignar probabilidad de cierre por nombre
          if (data.nombreProbabilidadCierre) {
            this.probabilidadCierre = data.nombreProbabilidadCierre.toUpperCase();
          }
          
          // Parsear y asignar canales de contacto (convertir IDs a nombres)
          if (data.canalesContacto) {
            this.canalesContacto = this.mapCanalesIdsToNames(data.canalesContacto);
          }
          
          // Asignar historial de observaciones y formatear fechas
          if (data.historialObservaciones && data.historialObservaciones.length > 0) {
            this.historialObservaciones = data.historialObservaciones.map(obs => ({
              ...obs,
              fecha: obs.fechaCreacion ? this.formatearFechaISO_DD_MM_YYYY(obs.fechaCreacion) : ''
            }));
          } else {
            this.historialObservaciones = [];
          }
          
          // console.log(' Datos de seguimiento cargados:');
          // console.log('  - idGestion:', this.idGestion);
          // console.log('  - Acción:', this.idGestion ? 'ACTUALIZAR' : 'CREAR');
          // console.log('  - Historial:', this.historialObservaciones);
        }
        this.spinner.hide();
        this.isLoading = false;
      },
      error: (error) => {
        console.error(' Error al cargar datos de seguimiento:', error);
        this.spinner.hide();
        this.isLoading = false;
        
        // Inicializar con valores por defecto
        this.idGestion = null;
        this.fechaProximoContacto = this.calcularFechaTresDiasHabiles();
      }
    });
  }
  
  /**
   * Parsea una fecha en formato ISO (YYYY-MM-DD) a objeto Date
   */
  parseFechaISO(fechaStr: string): Date {
    const partes = fechaStr.split('-');
    if (partes.length === 3) {
      const anio = parseInt(partes[0], 10);
      const mes = parseInt(partes[1], 10) - 1;
      const dia = parseInt(partes[2], 10);
      return new Date(anio, mes, dia);
    }
    return new Date();
  }
  
  /**
   * Mapea IDs de canales (string[]) a nombres de canales
   */
  mapCanalesIdsToNames(canales: string[] | null): string[] {
    if (!canales || canales.length === 0) return [];
    
    try {
      let idsArray: string[] = canales.map(id => id.trim());
      
      // Mapear cada ID a su nombre correspondiente
      return idsArray
        .map(id => {
          const canal = this.canalesAtencion.find(c => c.id_canal === id);
          return canal ? canal.nombre_canal.toUpperCase() : null;
        })
        .filter(nombre => nombre !== null) as string[];
    } catch (error) {
      console.error('Error al mapear canales:', error);
      return [];
    }
  }
  
  /**
   * Mapea nombres de canales a IDs de canales (como strings)
   */
  mapCanalesNamesToIds(canalesNombres: string[]): string[] {
    return canalesNombres
      .map(nombre => {
        const canal = this.canalesAtencion.find(
          c => c.nombre_canal.toUpperCase() === nombre.toUpperCase()
        );
        return canal ? canal.id_canal : null;
      })
      .filter(id => id !== null) as string[];
  }
  
  /**
   * Obtiene el ID de probabilidad de cierre por nombre
   */
  getProbabilidadCierreId(nombre: string): number | null {
    const probabilidad = this.probabilidadesCierre.find(
      p => p.nombre.toUpperCase() === nombre.toUpperCase()
    );
    return probabilidad ? probabilidad.idProbabilidadCierre : null;
  }
  
  /**
   * @deprecated Usar mapCanalesIdsToNames directamente con el array de IDs del backend
   */
  parseCanalesContacto(canales: string): string[] {
    if (!canales) return [];
    return this.mapCanalesIdsToNames(canales.split(',').map(id => id.trim()));
  }
  
  /**
   * Calcula 3 días hábiles después de hoy
   * Por simplicidad, suma 3 días (sin considerar fines de semana/festivos)
   * En producción, esto debería conectar con el servicio de días festivos
   */
  calcularFechaTresDiasHabiles(): Date {
    const fechaBase = new Date();
    
    // Sumar 3 días (simplificado, debería considerar días hábiles reales)
    fechaBase.setDate(fechaBase.getDate() + 3);
    return fechaBase;
  }
  
  onCancel(): void {
    this.dialogRef.close(null);
  }
  
  onGuardar(): void {
    if (this.esJefeComercial) {
      return;
    }
    // Validar campos obligatorios
    if (!this.fechaProximoContacto || !this.probabilidadCierre || this.canalesContacto.length === 0) {
      return;
    }
    
    if (this.observacionesError) {
      return;
    }
    
    // Si hay observación pendiente sin agregar al array, alertar al usuario
    if (this.observaciones.trim()) {
      this.showMessageDialog(
        'Observación pendiente',
        'Tiene una observación sin guardar. Por favor, haga clic en "Agregar observación" o elimine el texto.',
        'Aceptar',
        '',
        true,
        2,
        this.dialog,
        () => {}
      );
      return;
    }
    
    this.spinner.show();
    
    // Obtener ID de probabilidad
    const idProbabilidad = this.getProbabilidadCierreId(this.probabilidadCierre);
    if (!idProbabilidad) {
      this.spinner.hide();
      this.showMessageDialog(
        'Error',
        'No se pudo obtener el ID de la probabilidad de cierre',
        'Aceptar',
        '',
        true,
        2,
        this.dialog,
        () => {}
      );
      return;
    }
    
    // Convertir canales de nombres a IDs (como strings)
    const canalesIds = this.mapCanalesNamesToIds(this.canalesContacto);
    
    // Formatear fecha a YYYY-MM-DD
    const fechaFormateada = this.formatearFechaISO(this.fechaProximoContacto);
    
    // Construir request (sin idGestion, solo se usa en la URL para PUT)

    const request: SeguimientoModalRequest = {
      //usuarioGestion: '123456789',
      idCotizacion: this.data.idCotizacion,
      cliente: this.nombreCliente,
      usuarioGestion: this.usuarioGestion,
      canalesContacto: canalesIds,
      fechaProxContacto: fechaFormateada,
      idProbabilidad: idProbabilidad,
      observaciones: this.observacionesNuevas
    };
    
    // Decidir si crear o actualizar según idGestion
    const serviceCall = this.idGestion 
      ? this.networking.actualizarSeguimiento(this.idGestion, request)
      : this.networking.crearSeguimiento(request);
    
    // console.log('Guardando seguimiento:', this.idGestion ? 'ACTUALIZAR' : 'CREAR');
    // console.log('idGestion:', this.idGestion);
    // console.log('Request:', request);
    
    serviceCall.subscribe({
      next: (response) => {
        this.spinner.hide();
        if (response.status) {
          this.showMessageDialog(
            'Éxito',
            `Seguimiento ${this.idGestion ? 'actualizado' : 'creado'} exitosamente`,
            'Aceptar',
            '',
            true,
            1,
            this.dialog,
            () => {
              const estaEnMisCotizaciones = this.router.url
                .split('?')[0]
                .replace(/\/+$/, '') === '/main/miscotizaciones';

              this.dialogRef.close({
                success: true,
                idCotizacion: this.data.idCotizacion
              });

              if (!estaEnMisCotizaciones) {
                this.router.navigate(['/main/miscotizaciones']);
              }
            }
          );
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.showMessageDialog(
          'Error',
          error || 'Error al guardar el seguimiento',
          'Aceptar',
          '',
          true,
          2,
          this.dialog,
          () => {}
        );
      }
    });
  }

  /**
   * Formatea una fecha de Date a formato ISO (YYYY-MM-DD)
   */
  formatearFechaISO(fecha: Date): string {
    const anio = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const dia = String(fecha.getDate()).padStart(2, '0');
    return `${anio}-${mes}-${dia}`;
  }
  
  /**
   * Formatea una fecha en formato ISO (YYYY-MM-DDTHH:mm:ss o YYYY-MM-DD) a formato DD/MM/YYYY
   * Evita problemas de zona horaria parseando el string directamente
   */
  formatearFechaISO_DD_MM_YYYY(fechaISO: string): string {
    if (!fechaISO) return '';
    
    try {
      // Parsear fecha ISO: 2026-03-06 o 2026-03-03T22:14:03
      // Extraer solo la parte de la fecha (antes de 'T' si existe)
      const fechaParte = fechaISO.split('T')[0];
      const partes = fechaParte.split('-');
      
      if (partes.length === 3) {
        const anio = partes[0];
        const mes = partes[1];
        const dia = partes[2];
        return `${dia}/${mes}/${anio}`;
      }
      
      return fechaISO;
    } catch (error) {
      console.error('Error al formatear fecha:', error);
      return fechaISO;
    }
  }
  
  onObservacionesChange(): void {
    this.observacionesError = !!this.observaciones && this.observaciones.length > 1000;
  }
  
  agregarObservacion(): void {
    if (this.esJefeComercial) {
      return;
    }

    if (!this.observaciones.trim()) {
      return;
    }
    
    if (this.observaciones.length > 1000) {
      this.observacionesError = true;
      return;
    }
    
    // Agregar observación al array de observaciones nuevas
    this.observacionesNuevas.push(this.observaciones.trim());
    
    // También agregar al historial visual para que el usuario vea el cambio
    const fechaActual = new Date();
    const fechaFormateada = this.formatearFecha(fechaActual);
    
    this.historialObservaciones.unshift({
      fecha: fechaFormateada,
      observacion: this.observaciones.trim()
    });
    
    // Limpiar campo de observaciones
    this.observaciones = '';
    this.observacionesError = false;
    
    // console.log(' Observación agregada. Total nuevas:', this.observacionesNuevas.length);
  }
  
  formatearFecha(fecha: Date): string {
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const anio = fecha.getFullYear();
    return `${dia}/${mes}/${anio}`;
  }
  
  isGuardarDisabled(): boolean {
    return this.esJefeComercial ||
           !this.fechaProximoContacto || 
           !this.probabilidadCierre || 
           this.canalesContacto.length === 0 ||
           this.observacionesError;
  }
}
